(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-related-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    $('.ltn__related-product-slider-one-active').each(function () {
      var $slider = $(this);

      if (!$slider.hasClass('slick-initialized')) {
        $slider.slick({
          arrows: true,
          dots: false,
          infinite: true,
          speed: 300,
          slidesToScroll: 1,
          prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left"></i></a>',
          nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right"></i></a>'
        });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-product"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;

          $('.ltn__related-product-slider-one-active').slick({
              arrows: true,
              dots: false,
              infinite: true,
              speed: 300,
              slidesToScroll: 1,
              prevArrow: '<a class="slick-prev"><i class="fas fa-arrow-left" alt="Arrow Icon"></i></a>',
              nextArrow: '<a class="slick-next"><i class="fas fa-arrow-right" alt="Arrow Icon"></i></a>'
          });
          
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
